import './index.css'
import clsx from 'clsx'

import React, { useContext } from 'react'
import { CookieConsentProvider } from 'contexts/cookie-consent'
import { ThemeContext } from 'contexts/theme'

const PublicPage = ({
  children,
  fullHeight,
  backgroundWhite,
}: {
  children: React.ReactNode
  fullHeight?: boolean
  backgroundWhite?: boolean
}): React.ReactNode => {
  const theme = useContext(ThemeContext)?.theme
  return (
    <CookieConsentProvider>
      <div
        className={clsx('public-page', {
          'public-page--dark': theme === 'dark',
          'public-page--light': theme === 'light',
          'public-page--full-height': fullHeight,
          'public-page--background-white': backgroundWhite,
        })}
      >
        {children}
      </div>
    </CookieConsentProvider>
  )
}

export default PublicPage
